var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-contaziner",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
              _vm.supportsDefaultValues
                ? _c(
                    "w-dropdown",
                    {
                      attrs: { items: _vm.dropdownItems, right: "" },
                      on: {
                        click: function ($event) {
                          return $event()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-padding": "" } },
        [
          _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                { staticClass: "ef-root" },
                [
                  _c(
                    "w-col",
                    {
                      attrs: {
                        xs: "12",
                        md: _vm.supportsTabs ? 7 : 12,
                        lg: _vm.supportsTabs ? 8 : 12,
                      },
                    },
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
                          _c(
                            "w-card-content",
                            { staticClass: "ef-content" },
                            [
                              _c("div", { staticClass: "ef-topline" }, [
                                _c("span", { staticClass: "ef-subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$ct("fields-in-use", {
                                        used: _vm.usedCount,
                                        free: _vm.freeCount,
                                      })
                                    )
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "ef-switch" },
                                  [
                                    _c("w-switch", {
                                      attrs: {
                                        value: !_vm.settings.HideEditInBrowse,
                                        label: _vm.$ct("edit-from-browse"),
                                      },
                                      on: {
                                        input: function ($event) {
                                          _vm.settings.HideEditInBrowse =
                                            !$event
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._l(_vm.fieldTypes, function (type) {
                                return _c("app-extra-field-group", {
                                  key: type,
                                  attrs: {
                                    settings: _vm.settings,
                                    type: type,
                                    "extra-fields-type": _vm.fieldsType,
                                  },
                                })
                              }),
                            ],
                            2
                          ),
                          _c(
                            "w-card-actions",
                            [
                              _vm.supportsDefaultValues
                                ? _c(
                                    "w-button",
                                    {
                                      attrs: { flat: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setDefaultValues()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$ct("set-default-values"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("w-spacer"),
                              _c(
                                "w-button",
                                {
                                  staticClass: "cancel mr",
                                  on: {
                                    click: function ($event) {
                                      return _vm.cancel()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                              ),
                              _c(
                                "w-button",
                                {
                                  attrs: { icon: "check" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.save()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.save")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.supportsTabs
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12", md: "5", lg: "4" } },
                        [
                          _c(
                            "w-card",
                            [
                              _c("w-card-title", [
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("tabs-in-detail")) + " "
                                ),
                                _c("span", { staticClass: "ef-count ml" }, [
                                  _vm._v(_vm._s(_vm.settings.Tabs.length)),
                                ]),
                              ]),
                              _c(
                                "w-card-content",
                                [
                                  _c("w-info", {
                                    staticClass: "mb",
                                    attrs: {
                                      tiny: "",
                                      text: _vm.$ct("extra-field-tabs-info"),
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "ef-tabs" },
                                    [
                                      _vm._l(
                                        _vm.settings.Tabs,
                                        function (tab, i) {
                                          return _c(
                                            "span",
                                            {
                                              key: tab.ID,
                                              staticClass: "ef-chip",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: tab.Name,
                                                    expression: "tab.Name",
                                                  },
                                                ],
                                                ref: "tab" + tab.ID,
                                                refInFor: true,
                                                staticClass: "ef-chip-name",
                                                attrs: {
                                                  placeholder: _vm.$ct(
                                                    "tab-name-placeholder"
                                                  ),
                                                  size: Math.max(
                                                    4,
                                                    (tab.Name || "").length + 1
                                                  ),
                                                },
                                                domProps: { value: tab.Name },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      tab,
                                                      "Name",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "ef-chip-count",
                                                },
                                                [
                                                  _vm._v(
                                                    "· " +
                                                      _vm._s(
                                                        _vm.tabFieldCount(
                                                          tab.ID
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: _vm.$ct(
                                                        "remove-extra-field-tab"
                                                      ),
                                                      expression:
                                                        "$ct('remove-extra-field-tab')",
                                                    },
                                                  ],
                                                  staticClass: "ef-chip-x",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeTab(i)
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("w-fa", {
                                                    attrs: { icon: "times" },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "ef-chip add",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addTab()
                                            },
                                          },
                                        },
                                        [_vm._v("+ " + _vm._s(_vm.$ct("tab")))]
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }